import { render } from "./ActivityLogsView.vue?vue&type=template&id=025c6050"
import script from "./ActivityLogsView.vue?vue&type=script&lang=js"
export * from "./ActivityLogsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__